function generateTBillCSV({
  companyName = "TBill",
  startPrice = 980.35,  
  faceValue = 1000,
  months = 6,
  monthAdjust = 0,
  behavior = "1",
  createHeader = true
}) {
  const monthlyGain = (faceValue - startPrice) / months;
  const csvRows = [];

  if (createHeader) {
    csvRows.push({
      company: "investShortName",
      behavior: "behavior",
      monthNbr: "monthNbr",
      close: "closingPrice",
      open: "openPrice",
      high: "highPrice",
      low: "lowPrice",
      volume: "volume"
    });
  }

  for (let i = 0; i < months; i++) {
    const monthNbr = i + 1 + monthAdjust;

    const openPrice = startPrice + monthlyGain * i;
    const closePrice = startPrice + monthlyGain * (i + 1);

    // Optional tiny market-like wiggle
    const noiseFactor = 0.001; // ±0.1%
    const high = Math.max(openPrice, closePrice) * (1 + Math.random() * noiseFactor);
    const low = Math.min(openPrice, closePrice) * (1 - Math.random() * noiseFactor);

    csvRows.push({
      company: companyName,
      behavior: behavior,
      monthNbr: monthNbr.toString(),
      close: closePrice.toFixed(2),
      open: openPrice.toFixed(2),
      high: high.toFixed(2),
      low: low.toFixed(2),
      volume: "0.00"
    });
  }

  return csvRows;
}
export default generateTBillCSV;